import textInputModel from "../../../../models/general/elements/inputElements/textInput.model";
import TextInputElementComponent from "../../../general/elements/inputElements/TextInputElementComponent";

export const WebsiteConfigurationVatPercenteSection = ({ props }) => {
  const { currentValue, handleChange } = props;

  const getDiscountInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "Discount",
      value: currentValue,
      onChange: handleChange,
      label: "אחוז הנחה כללי באתר",
      min: 0,
      type: "number",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  return getDiscountInputElement();
};

export default WebsiteConfigurationVatPercenteSection;
